module.exports = require("././ngStorage.js");


//////////////////
// WEBPACK FOOTER
// ngstorage (bower component)
// module id = 1024
// module chunks = 1